import { APP_PREFIX_PATH } from "configs/AppConfig";
import { USER_ROLES } from "configs/UserRoleConfig";

const routeConfig = [
	{
		key: "zodiacSystemUsers",
		path: `${APP_PREFIX_PATH}/users/list`,
		component: `./Users/AllUsers`,
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		exact: false,
	},
	{
		key: "zodiacSystem",
		path: `${APP_PREFIX_PATH}/list`,
		component: `./Zodiac/AllZodiacSystem`,
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		exact: false,
	},
	{
		key: "account",
		path: `${APP_PREFIX_PATH}/account`,
		component: `./Account/index`,
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		exact: false,
	},
	{
		key: "zodiacSystemView",
		path: `${APP_PREFIX_PATH}/view/:id/:locker?`,
		component: `./Zodiac/ViewLockerSystem`,
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		exact: false,
	},
	{
		key: "zodiacSystemAdminList",
		path: `${APP_PREFIX_PATH}/admin`,
		component: `./Administrators/List/List`,
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		exact: false,
	},
	{
		key: "zodiacSystemAdminRoles",
		path: `${APP_PREFIX_PATH}/roles`,
		component: `./Administrators/Role/Role`,
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		exact: false,
	},
	{
		key: "zodiacSystemAbout",
		path: `${APP_PREFIX_PATH}/about`,
		component: `./home/About`,
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		exact: false,
	},
];

export default routeConfig;
